import { z } from 'zod';

import type { BinaryAnswer } from '@/constants/answers';
import i18n from '@/lib/i18n';
import { institutionDetailsCompanySchema, institutionDetailsV2ProductsSchema } from '@/services/api/profile';

export type InstitutionProducts = {
  futures?: BinaryAnswer;
  // Saved to the company section, which futures needs it in
  leiNumber: string;
};

export type InstitutionProductsOrDefaults = InstitutionProducts | Partial<InstitutionProducts>;

export const institutionProductsLeiNumberSchema = z.object({
  leiNumber: z.string().min(1, i18n.t('institutionDetails.products.errors.leiNumber')).pipe(institutionDetailsCompanySchema.shape.leiNumber.unwrap()),
});

export const institutionProductsSchema = z.discriminatedUnion('futures', [
  z.object({ futures: z.literal('NO') }),
  institutionProductsLeiNumberSchema.extend({ futures: z.literal('YES') }),
]);

export const institutionProductsToInstitutionDetailsProductsApi = ({ futures }: InstitutionProducts) => institutionDetailsV2ProductsSchema.parseAsync({ futures });
